<nav mat-tab-nav-bar style="margin-top: 63px">
    <a
        *ngIf="isTabMenuVisible('/finanzen/rechnungen')"
        mat-tab-link
        [routerLink]="['/finanzen/rechnungen']"
        routerLinkActive
        #rla="routerLinkActive"
        [active]="rla.isActive"
        >Rechnungen</a
    >
    <a
        *ngIf="isTabMenuVisible('/finanzen/gutschriften')"
        mat-tab-link
        [routerLink]="['/finanzen/gutschriften']"
        routerLinkActive
        #gla="routerLinkActive"
        [active]="gla.isActive"
        >Gutschriften</a
    >
    <a
        *ngIf="isTabMenuVisible('/finanzen/primanota')"
        mat-tab-link
        [routerLink]="['/finanzen/primanota']"
        routerLinkActive
        #prla="routerLinkActive"
        [active]="prla.isActive"
        >Primanotas</a
    >
    <a
        *ngIf="isKontenrahmenBereichVisible()"
        mat-tab-link
        [routerLink]="getKontenrahmenBereichLink()"
        [active]="isKontenrahmenBereichActive()"
        >Kontenrahmen</a
    >
    <a
        *ngIf="isTabMenuVisible('/finanzen/nebenkosten-artikel')"
        mat-tab-link
        [routerLink]="['/finanzen/nebenkosten-artikel']"
        routerLinkActive
        #nkla="routerLinkActive"
        [active]="nkla.isActive"
        >Nebenkosten-Artikel</a
    >
</nav>
<router-outlet></router-outlet>
